module.exports = __webpack_public_path__ + "img/minter-t.91f2e1ca.gif";